import { PageLink } from '../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Menu',
    path: '/menus',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
